import { ESeparateWallType } from '@/editor/data/separateWall/SeparateWall';
import { ELayoutWallType } from '@/service/layout/types';

export const convertLayoutWallTypeToSeparateWallType = (autolayoutType: ELayoutWallType): ESeparateWallType => {
  switch (autolayoutType) {
    case ELayoutWallType.GlassSeparateWall:
      return ESeparateWallType.GlassWall;
    case ELayoutWallType.HalfGlassSeparateWall:
      return ESeparateWallType.HalfGlassWall;
    case ELayoutWallType.VirtualSeparateWall:
      return ESeparateWallType.VirtualWall;
    case ELayoutWallType.SolidSeparateWall:
      return ESeparateWallType.SolidTabletWall;
    default:
      console.warn('Unknown autolayout wall type:', autolayoutType);
      return ESeparateWallType.Empty;
  }
};

export const convertSeparateWallTypeToLayoutWallType = (separateWallType: ESeparateWallType): ELayoutWallType => {
  switch (separateWallType) {
    case ESeparateWallType.GlassWall:
      return ELayoutWallType.GlassSeparateWall;
    case ESeparateWallType.HalfGlassWall:
      return ELayoutWallType.HalfGlassSeparateWall;
    case ESeparateWallType.VirtualWall:
    case ESeparateWallType.BaseVirtualWall:
      return ELayoutWallType.VirtualSeparateWall;
    case ESeparateWallType.SolidTabletWall:
      return ELayoutWallType.SolidSeparateWall;
    default:
      console.warn('Unknown separate wall type:', separateWallType);
      return ELayoutWallType.VirtualSeparateWall;
  }
};
